import api from '@/shared/api/api';

export const notificationApi = {
  /** List notifications with limit */
  list: (limit = 20) => api.get(`/notifications?limit=${limit}`).then((r: any) => r.data),

  /** Mark a single notification as read */
  markAsRead: (notificationId: any) => api.post(`/notifications/mark-read/${notificationId}`).then((r: any) => r.data),

  /** Mark all notifications as read */
  markAllAsRead: () => api.post('/notifications/mark-all-read').then((r: any) => r.data),

  /** Delete a notification */
  remove: (notificationId: any) => api.delete(`/notifications/${notificationId}`).then((r: any) => r.data),

  /** Subscribe to push notifications */
  subscribePush: (subscription: any) =>
    api.post('/notifications/subscribe-push', subscription).then((r: any) => r.data),

  /** Unsubscribe from push notifications */
  unsubscribePush: () => api.delete('/notifications/unsubscribe-push').then((r: any) => r.data),

  /** Get notification preferences */
  getPreferences: () => api.get('/user/me/notification-preferences').then((r: any) => r.data),

  /** Update notification preferences */
  updatePreferences: (data: any) => api.put('/user/me/notification-preferences', data).then((r: any) => r.data),
};
